import { useQueryClient } from "@tanstack/react-query";
import * as Sentry from "@sentry/react";
import toast from "react-hot-toast";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";

export function useRenameTaskAttachment() {
  const queryClient = useQueryClient();

  return async (attachmentId: string, newName: string): Promise<boolean> => {
    const trimmed = newName.trim();
    if (!trimmed) return false;

    const { error } = await supabase
      .from("task_attachments")
      .update({ file_name: trimmed })
      .eq("id", attachmentId);

    if (error) {
      Sentry.captureException(error, {
        extra: { mutation: "useRenameTaskAttachment", attachmentId },
      });
      toast.error("Failed to rename attachment. Please try again.");
      return false;
    }

    queryClient.invalidateQueries({ queryKey: queryKeys.tasks });
    return true;
  };
}

export function useRenameSubtaskAttachment() {
  const queryClient = useQueryClient();

  return async (attachmentId: string, newName: string): Promise<boolean> => {
    const trimmed = newName.trim();
    if (!trimmed) return false;

    const { error } = await supabase
      .from("subtask_attachments")
      .update({ file_name: trimmed })
      .eq("id", attachmentId);

    if (error) {
      Sentry.captureException(error, {
        extra: { mutation: "useRenameSubtaskAttachment", attachmentId },
      });
      toast.error("Failed to rename attachment. Please try again.");
      return false;
    }

    queryClient.invalidateQueries({ queryKey: queryKeys.tasks });
    return true;
  };
}
